module.exports = __webpack_public_path__ + "static/media/stickman_run_3.1161696b.png";